import { render, staticRenderFns } from "./target-wallet-modal.vue?vue&type=template&id=38763ee2&scoped=true&"
import script from "./target-wallet-modal.vue?vue&type=script&lang=js&"
export * from "./target-wallet-modal.vue?vue&type=script&lang=js&"
import style0 from "./target-wallet-modal.vue?vue&type=style&index=0&id=38763ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38763ee2",
  null
  
)

export default component.exports